import React from "react";
import style from "./offer.module.css";
import Lastreons from "../../../Assets/Lastreons.png";
import CoinBox from "../../../Assets/CoinBox.png";

export default function Offer ({ price1 = 320, price2 = 0, price3 = 3 }) {

    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <div className={style.coinsDiv} style={{background: isHovered ? "rgba(67, 108, 42, 0.5)" : "rgba(13, 13, 13, 0.5)"}}>
            <img src={CoinBox} alt="CoinBox"/>
            <div className={style.price}>
                <p>{price1}</p>
                <img src={Lastreons} alt="Lastreons"/>
            </div>
            <div className={style.bonus}>
                <p>+</p>
                <p>BONUS!</p>
            </div>
            <div className={style.bonusPrice}>
                <p>{price2}</p>
                <img src={Lastreons} alt="Lastreons"/>
            </div>
            <button onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} className={style.button}>{price3}€</button>
        </div>
    );
};